export const inspections = {
shared: {
  jobVisibility: {
    contractors: "Sous-traitants",
    team: "Équipe",
    private: "Privée",
  },
  jobCategory: {
    Other: "Autre",
    Cleaning: "Nettoyage",
    Installation: "Pose",
    Replacement: "Remplacement",
    Inspection: "Inspection",
    Maintenance: "Maintenance",
    Repair: "Réparation",
  },
checklistCategory: {
Inspection: "Inspection",
Check: "Vérification",
Audit: "Contrôle",
SafetyReview: "Revue de sécurité",
Maintenance: "Maintenance",
General: "Général",
},
itemsAnswered_one: "{{value}} sur {{count}} élément renseigné ({{percent}}%)",
itemsAnswered_many: "{{value}} sur {{count}} d’éléments renseignés ({{percent}}%)",
itemsAnswered_other: "{{value}} sur {{count}} éléments renseignés ({{percent}}%)",
workflowRationale: {
explicit: "Choisi pour cette inspection.",
lastUsed: "Dernier utilisé pour cet actif.",
bestMatch: "Le déroulé le plus adapté à ce type d’actif.",
history: "D’après les {{inspections}} les plus récentes de cet actif ({{every}}).",
historyInspections_one: "{{count}} inspection",
historyInspections_many: "{{count}} d’inspections",
historyInspections_other: "{{count}} inspections",
historyEvery_one: "environ tous les jours",
historyEvery_many: "environ tous les {{count}} de jours",
historyEvery_other: "environ tous les {{count}} jours",
assetTypeDefault: {
car: "Fréquence de départ habituelle pour les véhicules — à ajuster si besoin.",
property: "Fréquence de départ habituelle pour les biens immobiliers — à ajuster si besoin.",
equipment: "Fréquence de départ habituelle pour les équipements — à ajuster si besoin.",
other: "Fréquence de départ habituelle pour les autres actifs — à ajuster si besoin.",
},
},
executionMode: {
list: "Liste",
guidedGroup: "Guidé par groupe",
guidedItem: "Guidé par élément",
},
recordStatus: {
inProgress: "En cours",
paused: "En pause",
submitted: "Soumis",
approved: "Validée",
completed: "Terminé",
cancelled: "Annulé",
},
},
start: {
  planningLoadErrorTitle: "Impossible d’ouvrir la planification",
  planningAssetUnavailable: "Cet actif n’est pas disponible, ou vous n’y avez plus accès.",
  planningAssetMismatch: "Cette demande concerne un autre actif. Ouvrez la demande et réessayez.",
  planningLoading: "Préparation en cours…",
  planningTitle: "Planifier le travail",
setupRequiredTitle: "Configuration requise",
setupRequiredBodyAll: "Ajoutez au moins un actif et une checklist avant de démarrer une inspection.",
setupRequiredBodyAssets: "Ajoutez au moins un actif avant de démarrer une inspection.",
setupRequiredBodyTemplates: "Créez au moins une checklist avant de démarrer une inspection.",
addAsset: "Ajouter un actif",
createChecklist: "Créer une checklist",
createChecklistA11y: "Créer une checklist",
createChecklistSheetTitle: "Créer une checklist",
createChecklistSheetSubtitle: "Choisissez comment créer votre checklist.",
createChecklistWithAi: "Générer avec l'IA",
createChecklistManually: "Créer manuellement",
overlayReturnFootnote: "S'ouvre dans une fenêtre superposée. Une fois enregistré, vous revenez ici pour démarrer ou planifier.",
stepSelectAsset: "1. Sélectionner l'actif",
searchAssetsPlaceholder: "Rechercher des actifs",
searchAssetsA11y: "Rechercher des actifs",
allTypesA11y: "Afficher tous les types d'actifs",
tapSelectedAssetToChange: "Appuyez sur l'actif sélectionné pour le changer.",
noAssetsMatch: "Aucun actif ne correspond à votre recherche.",
stepSelectChecklist: "2. Sélectionner la checklist",
noChecklistsForAssetType: "Aucune checklist ne correspond au type d'actif {{assetType}}.",
selectAssetFirst: "Sélectionnez d'abord un actif pour afficher les checklists compatibles.",
searchChecklistsPlaceholder: "Rechercher des checklists",
searchChecklistsA11y: "Rechercher des checklists",
showingChecklistsFor: "Checklists affichées pour {{assetType}}",
tapSelectedChecklistToChange: "Appuyez sur la checklist sélectionnée pour la changer.",
noChecklistsMatch: "Aucune checklist ne correspond à votre recherche.",
stepAssignInspector: "3. Assigner et démarrer",
youSuffix: " (Vous)",
you: "Vous",
onlyTeamMember: "Seul votre membre d'équipe est disponible pour le moment.",
createTeamToAssign: "Créez une équipe pour assigner des inspections à d'autres personnes.",
executionModeLabel: "Mode d'exécution",
locationTitle: "Position actuelle",
locationLoading: "Vérification de votre position...",
locationNotSupported: "La localisation n'est pas prise en charge sur cet appareil.",
locationPermissionDenied: "L'autorisation de localisation a été refusée.",
locationUnavailableFallback: "La position est indisponible.",
locationUnavailableMessage: "Position indisponible : {{reason}}",
starting: "Démarrage...",
startInspection: "Démarrer l'inspection",
prefilledMomentumHint: "Vérifiez les choix ci-dessous, puis appuyez sur Démarrer l'inspection.",
scheduleForLater: "Planifier pour plus tard",
noPriority: "Aucune priorité",
requestContextEyebrow: "Inspection pour la demande",
requesterNotSet: "Non défini",
requestHandoff: {
requesterFallback: "le demandeur",
decisionStartNow: "Décision : démarrer maintenant",
},
alerts: {
selectAsset: "Sélectionnez un actif avant de continuer.",
selectChecklist: "Sélectionnez une checklist avant de continuer.",
selectAssetAndChecklist: "Sélectionnez un actif et une checklist pour démarrer.",
assetArchivedTitle: "Actif archivé",
assetArchivedBody: "Les actifs archivés ne peuvent pas être inspectés. Choisissez un autre actif.",
assetArchivedScheduleBody: "Les actifs archivés ne peuvent pas être planifiés pour inspection. Choisissez un autre actif.",
couldNotStartTitle: "Impossible de démarrer l'inspection",
couldNotStartBody: "Veuillez réessayer.",
},
},
share: {
title: "Partager le rapport",
},
report: {
coverEyebrow: "Rapport d'état",
coverUntitled: "Actif sans titre",
sectionSubject: "Sujet",
statInspected: "Inspecté",
statRepairs: "Réparations",
statEstTotal: "Total est.",
},
sentForApproval: {
subtitle: "Nous enverrons un lien de revue par e-mail. Vous serez averti lors de la réponse.",
backToHome: "Retour à l'accueil",
viewReport: "Voir le rapport",
},
detail: {
  sendBack: {
    errors: {
      notAllowed: "Seule la personne qui valide le travail sur cet actif peut la renvoyer.",
      notWaiting: "Cette inspection n’attend plus de validation. Quelqu’un vient peut-être de l’approuver ou de la renvoyer.",
      ownWork: "Vous ne pouvez pas renvoyer une inspection que vous avez faite vous-même.",
      reasonRequired: "Écrivez entre 3 et 1 000 caractères pour que la personne sache quoi corriger.",
    },
    noticeHint: "Corrigez ce qui est demandé, puis touchez à nouveau « Terminer l’inspection ». Elle leur revient pour validation.",
    noticeReason: "« {{reason}} »",
    noticeTitle: "{{name}} a renvoyé cette inspection",
    approverFallback: "La personne qui valide",
    inspectorFallback: "l’inspecteur",
    failedTitle: "Impossible de la renvoyer",
    sent: "Renvoyée à {{name}}. Cette personne verra votre raison.",
    sending: "Renvoi en cours…",
    confirm: "Renvoyer",
    reasonTooShort: "Écrivez quelques mots pour que la personne sache quoi corriger.",
    reasonPlaceholder: "Par exemple : ajoutez une photo de l’évacuation du toit.",
    reasonLabel: "Ce qu’il faut corriger",
    hint: "Indiquez ce qu’il faut corriger. {{name}} reçoit une notification et l’inspection se rouvre pour cette personne.",
    title: "Renvoyer à {{name}}",
    buttonA11y: "Renvoyer cette inspection à {{name}} avec une raison",
    button: "Renvoyer",
  },
  errors: {
    completeTitle: "Impossible de terminer l’inspection",
    deleteTitle: "Impossible de supprimer l’inspection",
    continueTitle: "Impossible de reprendre l’inspection",
    takeOverTitle: "Impossible de le faire à leur place",
    reopenTitle: "Impossible de rouvrir l’inspection",
    approveTitle: "Impossible d’approuver l’inspection",
    suggestionTitle: "Impossible d’ajouter cette suggestion",
    reloadTitle: "Impossible de charger leur version",
    mergeTitle: "Impossible de garder vos réponses",
    checkConnection: "Vérifiez votre connexion et réessayez.",
  },
  outline: {
    title: "Points · {{done}} sur {{total}} renseignés",
    jumpA11y: "Aller au point {{n}}, {{label}}, {{state}}",
    state: { failed: "non conforme", done: "renseigné", skipped: "ignoré", pending: "à renseigner" },
  },
findingsNextActionsTitle: "Constats et prochaines actions",
assetContext: {
asset: "Actif",
previousOnThisAsset: "Précédent sur cet actif",
manuals: "Manuels",
noAssetLinked: "Aucun actif lié",
openAsset: "Ouvrir l'actif →",
openAssetA11y: "Ouvrir l’actif",
},
approval: {
  fixAndResend: "Corriger et renvoyer",
  fixHint: "Corrigez ce qui est demandé, puis renvoyez le rapport.",
  changesAskedNoReason: "{{name}} a demandé des modifications.",
  changesAsked: "{{name}} a demandé des modifications : « {{reason}} »",
  linkCopied: "Lien copié. Collez-le dans un message à {{name}}.",
  sendAgainA11y: "Envoyer à nouveau le rapport à {{name}}",
  sendAgain: "Envoyer à nouveau",
  sentToDue: "Envoyé à {{name}} le {{date}} · réponse attendue le {{due}}",
  sentTo: "Envoyé à {{name}} le {{date}}",
  summary: {
    nextNotShared: "Terminez l’inspection, puis partagez le rapport si quelqu’un doit l’approuver.",
    nextWaitingFor: "En attente de la validation de {{name}}.",
    nextWaitingForTeam: "En attente de la validation de cette inspection par quelqu'un de {{name}}.",
    nextStepWaited_many: "{{nextStep}} En attente depuis {{count}} jours.",
    nextStepWaited_one: "{{nextStep}} En attente depuis {{count}} jour.",
    nextStepWaited_other: "{{nextStep}} En attente depuis {{count}} jours.",
    nextYouApprove: "Vérifiez les constats, puis touchez Valider.",
    nextWaitingShared: "En attente de la réponse de la personne avec qui vous l’avez partagé.",
    nextResponded: "Lisez la réponse et décidez de la suite.",
    nextRespondedJobs: "Les réparations approuvées peuvent devenir des interventions.",
    nextChangesRequested: "Lisez les commentaires, mettez à jour l’inspection, puis partagez-la à nouveau.",
    nextApproved: "Validée. Ouvrez Prochaines étapes ou partagez le rapport.",
    nextApprovedJobs: "Vérifiez les réparations approuvées, puis créez les interventions.",
    noApproverYet: "Pas encore d’approbateur",
    recipientFallback: "Destinataire",
    statusNotShared: "Non partagée",
    statusAwaiting: "En attente de validation",
    statusResponded: "Réponse reçue",
    statusChangesRequested: "Modifications demandées",
    statusApproved: "Validée",
  },
  askAiDraft: "Aide-moi à revoir l’inspection {{checklist}} de {{asset}} du {{date}} et à décider de la suite.",
  closeIt: "Clôturer",
  keepWaiting: "Continuer d’attendre",
  closeConfirmBody: "{{name}} n’a pas répondu. Les réparations proposées seront enregistrées comme non approuvées, en son nom.",
  closeConfirmTitle: "Clôturer sans réponse ?",
  takeOverSignedOff: "Approuvé à la place de {{name}}",
  takeOverClosed: "Clôturé sans réponse",
  takeOverApproved: "Approuvé pour {{name}}",
  teamApprover: "Tout membre de {{name}}",
  assetApprover: "Approbateur de l’actif",
  approverFallback: "l’approbateur",
  reopenConfirm: "Rouvrir",
  reopenConfirmBody: "Vous pourrez modifier les réponses, puis terminer à nouveau l’inspection.",
  reopenConfirmApproved: "{{name}} l’a approuvée. La rouvrir annule cette approbation : il faudra l’approuver de nouveau.",
  reopenConfirmTitle: "Rouvrir cette inspection ?",
approval: "Approbation",
statusSummaryA11y: "Statut d'approbation : {{status}}. {{action}}",
collapse: "Réduire",
showDetails: "Afficher les détails",
currentStatus: "Statut actuel",
approver: "Approbateur",
nextStep: "Prochaine étape",
approveInspectionA11y: "Valider cette inspection",
approving: "Validation…",
approveInspection: "Valider",
openNextStepsA11y: "Ouvrir les étapes suivantes",
nextSteps: "Prochaines étapes",
shareReportA11y: "Partager le rapport",
shareReport: "Partager le rapport",
reopenAndClearA11y: "Rouvrir cette inspection et annuler son approbation",
reopenA11y: "Rouvrir cette inspection",
reopening: "Réouverture…",
reopenAndClear: "Rouvrir et annuler l’approbation",
reopenInspection: "Rouvrir l’inspection",
},
lifecycle: {
pauseTitle: "Suspendre l'inspection",
pauseHint: "Ajoutez éventuellement une raison et planifiez la reprise.",
reasonOptional: "Raison (facultatif)",
pauseReasonPlaceholder: "par ex. En attente de pièces, besoin de l'approbation du client",
resumeDateOptional: "Date de reprise (facultatif)",
selectDate: "Choisir une date",
resumeTimeOptional: "Heure de reprise (facultatif)",
selectTime24h: "Sélectionner l'heure (24h)",
cancel: "Annuler",
pause: "Mettre en pause",
cancelTitle: "Annuler l'inspection",
cancelHint: "La progression est enregistrée mais l'inspection sera marquée comme annulée. Veuillez fournir une raison.",
cancellationReason: "Motif d'annulation",
cancelReasonPlaceholder: "par ex. Actif vendu, inspection en double, mauvaise liste de contrôle",
back: "Garder l’inspection",
cancelInspection: "Annuler l'inspection",
reassignTitle: "Réaffecter l'inspection",
reassigned: "Réaffectée à {{name}}. L'inspection reste en cours pour cette personne.",
reassignFailed: "Impossible de réaffecter l'inspection. Réessayez.",
pickContractorTitle: "La confier à un prestataire",
contractorNoAccountTitle: "Pas encore de compte AssetWRX",
contractorNoAccountBody: "{{name}} a besoin d'un compte AssetWRX pour réaliser une inspection. Invitez-le depuis Contacts ; une fois inscrit, vous pourrez la lui confier.",
cancelReasonRequired: "Veuillez indiquer un motif d'annulation.",
cancelledTitle: "Annulée",
cancelledBody: "L'inspection a été annulée.",
cancelFailed: "Impossible d'annuler l'inspection. Réessayez.",
pauseFailed: "Impossible de mettre l'inspection en pause. Réessayez.",
errorTitle: "Erreur",
searchTeamMembersPlaceholder: "Rechercher les membres de l’équipe…",
noTeamMemberMatch: "Aucun membre de l'équipe ne correspond.",
skipTitle: "Passer cet élément ?",
skipHint: "Ajoutez une courte note si cela aide votre équipe (facultatif). Appuyez sur Passer pour confirmer.",
noteOptional: "Note (facultatif)",
skipReasonPlaceholder: "par ex. Pas d'accès, sans objet",
skip: "Passer",
},
repair: {
proposedFollowUp: "Une intervention est nécessaire ?",
confirmedAfterCompletion: "(confirmé une fois terminé)",
markForFollowUp: "Oui, créer une intervention",
titleField: "Titre *",
titlePlaceholder: "par ex. Réparer le robinet qui fuit",
priority: "Priorité",
priorityFallback: "Moyenne",
description: "Description*",
descriptionPlaceholder: "Que faut-il faire...",
descriptionFallback: "Aucun",
hideOptionsA11y: "Masquer les options de suivi",
showOptionsA11y: "Afficher plus d'options de suivi",
lessOptions: "Moins d'options",
moreOptions: "Plus d'options",
repairCategory: "Catégorie de réparation",
repairCategoryFallback: "Réparation",
skillsOptional: "Compétences (facultatif)",
skills: "Compétences",
selected: "Sélectionné",
none: "Aucun",
dueDateOptional: "Date d’échéance (facultatif)",
visibility: "Visibilité",
visibilityFallback: "Privé",
estimatedCostOptional: "Coût estimé (facultatif)",
notSet: "Non défini",
costPlaceholder: "0,00",
requiresUrgentRepair: "Nécessite une réparation urgente",
urgentRepairNoteLabel: "Note de réparation urgente",
noNote: "Aucune remarque",
markFollowUpHintPrefix: "Une fois l’inspection terminée, vous confirmerez cette intervention dans ",
markFollowUpHintSuffix: " avant sa création.",
},
urgentNote: {
placeholder: "Pourquoi urgent ?",
stop: "Arrêter",
dictate: "Dicter",
cleaningUpEllipsis: "Nettoyage...",
aiCleanUp: "Nettoyage IA",
addNoteFirstTitle: "Ajouter d'abord une note",
addNoteFirstBody: "Tapez une courte note avant d’utiliser le nettoyage IA.",
cleaningUp: "Nettoyage d'une note urgente",
unableToCleanUpTitle: "Impossible de nettoyer la note",
cleanedUpTitle: "Note urgente nettoyée",
reviewSuggestedWording: "Vérifiez la formulation suggérée avant de l'appliquer.",
},
followUpModal: {
eyebrow: "Action d'inspection",
title: "Une intervention est nécessaire ?",
closeA11y: "Fermer le suivi",
saveHint: "Cochez-la, puis terminez l’inspection. Vous confirmerez l’intervention avant sa création.",
doneEditingA11y: "Modification du suivi proposé terminée",
done: "Terminé",
},
imageFindingsOverlay: {
findingA11y: "Constat : {{label}}",
confidenceSeverity: "Confiance : {{confidence}}% · Gravité : {{severity}}",
removeMarkerA11y: "Supprimer le marqueur du constat",
removeMarker: "Supprimer le marqueur",
close: "Fermer",
},
quickRating: {
quickRatingA11y: "Évaluation rapide",
yes: "Oui",
no: "Non",
quickLevelA11y: "Niveau rapide",
conditionRatingA11y: "Évaluation de l’état",
},
imageViewer: {
couldNotLoad: "Impossible de charger l'image",
closeA11y: "Fermer la visionneuse d’images",
},
noteSheet: {
eyebrow: "Note d'inspection",
title: "Ajouter une note",
closeA11y: "Fermer la note",
hint: "Tapez-la ou dictez-la : elle arrive dans la même note.",
placeholder: "Ajouter des notes d'inspection...",
dictateStop: "Arrêter de dicter",
dictateFinishing: "Finalisation…",
dictateUnavailable: "Dictée indisponible",
dictateIdle: "Dicter",
doneA11y: "Terminé",
done: "Terminé",
},
imageAnalysis: {
coverage: {
observed: "Visible",
partial: "Partiellement visible",
not_observed: "Non visible : répondez manuellement",
},
analysePhoto: "Analyser la photo avec l'IA",
analysePhotoA11y: "Analyser la photo avec l'IA",
aiQueued: "Analyse IA en file d'attente",
photoAnalysisTitle: "Analyse de la photo",
analysing: "Analyse...",
suggestedComment: "Commentaire suggéré",
severity: "Gravité : {{severity}}",
status: "Statut : {{status}}",
findings: "Constats",
appendToComments: "Ajouter aux commentaires",
replaceComments: "Remplacer les commentaires",
ignore: "Ignorer",
removeFindingA11y: "Supprimer le résultat {{label}}",
remove: "Supprimer",
replaceConfirmTitle: "Remplacer les commentaires ?",
replaceConfirmBody: "Cela remplacera votre note existante par la suggestion de l’IA.",
replaceConfirmCancel: "Annuler",
replaceConfirmReplace: "Remplacer",
},
runnerHeader: {
doneCount: "{{completed}}/{{total}} terminé",
failCount: "{{count}} à suivre",
urgentCountLabel_one: "{{count}} urgent",
urgentCountLabel_many: "{{count}} urgents",
urgentCountLabel_other: "{{count}} urgents",
modeLabel: {
list: "Liste",
guidedGroup: "Par groupe",
guidedItem: "Par élément",
},
modeDesc: {
list: "Voir tous les éléments en même temps",
guidedGroup: "Un groupe à la fois",
guidedItem: "Un élément à la fois",
},
cancelled: "Annulé",
paused: "En pause",
sectionEyebrow: "Section {{index}} de {{count}}",
openAssetA11y: "Ouvrir {{assetName}}",
openSyncConflictA11y: "Ouvrir les options de conflit de synchronisation",
retrySaveA11y: "Réessayez d’enregistrer les réponses d’inspection",
review: "Vérifier",
retry: "Réessayer",
askAiCompactA11y: "En fonction de vos réponses, l'IA peut vous aider lors des prochains contrôles",
askAiWideA11y: "L’IA peut vous aider lors des prochains contrôles",
jumpToIncompleteA11y: "Passer à l'élément requis incomplet suivant",
jumpToIncomplete: "Aller aux éléments incomplets",
changeModeA11y: "Changer le mode d'affichage. Actuel : {{mode}}",
viewAsTitle: "Afficher cette inspection comme",
modeOptionA11y: "{{mode}} : {{desc}}",
viewModeAction: "Vue : {{mode}}",
viewModeTooltip: "Changer la façon dont la liste de contrôle est présentée",
},
},
overview: {
statusApproved: "Approuvé",
statusCompleted: "Terminé",
statusCancelled: "Annulé",
statusPaused: "En pause",
statusInProgress: "En cours",
items: "Éléments",
progress: "Progression",
failures: "Échecs",
urgent: "Urgent",
resumeLabel: "Reprendre : {{text}}",
operationalTimelineA11y_one: "Chronologie opérationnelle, {{count}} événement",
operationalTimelineA11y_other: "Chronologie opérationnelle, {{count}} événements",
operationalTimelineTitle: "Chronologie opérationnelle · {{count}}",
whoLabel: "Qui : {{actor}}",
whenLabel: "Quand : {{when}}",
operationalTimelineA11y_many: "Chronologie opérationnelle, {{count}} événements",
},
photoEvidence: {
photos: "Photos",
mediaGuidance: "Jusqu'à 3 photos par élément · dessinez pour mettre en évidence avant de sauvegarder.",
noPhotosTaken: "Aucune photo prise",
evidencePhotoA11y: "{{label}} — photo de preuve {{index}} de {{count}}. Afficher en taille réelle",
},
shareSection: {
  statusChanges: "Modifications demandées",
  statusApproved: "Approuvé",
  statusWaiting: "En attente",
  messageA11y: "Ouvrir la revue avec {{name}}",
reportSharedWith: "Rapport partagé avec",
message: "Message",
createJobs: "Créer des interventions",
revoke: "Révoquer",
revokeAccessA11y: "Révoquer l’accès au rapport pour {{name}}",
revokeConfirmTitle: "Révoquer l'accès au rapport ?",
revokeConfirmBody: "{{name}} ne pourra plus ouvrir le lien du rapport. L’historique des partages est conservé.",
revokeConfirmCancel: "Annuler",
revokeConfirmConfirm: "Révoquer l'accès",
revokeFailedTitle: "Impossible de révoquer l'accès",
revokeFailedBody: "Veuillez réessayer dans un instant.",
recipientFallback: "Ce destinataire",
},
checklistSection: {
batchHintRange: "Éléments {{from}}–{{to}} sur {{total}}",
prefillNotice: "Inspection précédente{{dateSuffix}}. Les résultats et notes de la dernière fois sont affichés pour référence. Enregistrez le résultat actuel pour chaque contrôle.",
prefillNoticeDateSuffix: " du {{date}}",
emptyGroup: "Rien à compléter dans ce groupe.",
},
evidenceRail: {
collapseA11y: "Réduire {{title}}",
hide: "Masquer",
},
swipeableWrap: {
ok: "OK",
skip: "Sauter",
},
kpis: {
items: "Éléments",
status: "Statut",
cost: "Coût est.",
reviews: "Vérifications",
percentDone: "{{percent}}% terminé",
statusInProgress: "En cours",
},
summaryCard: {
  suggestedTitle: "Résumé suggéré",
title: "Résumé de l’inspection",
editSummary: "Modifier le résumé",
noSummaryYet: "Pas encore de résumé",
generatedAt: "Généré {{date}}",
regenerate: "Régénérer",
generate: "Générer",
generating: "Génération...",
buildingSummary: "Création du résumé à partir des données de l'inspection...",
noCredits: "Plus de crédits d'utilisation : le résumé ne peut pas être rédigé. Achetez un pack de crédits ou attendez vos crédits mensuels inclus.",
noCreditsMember: "Plus de crédits d'utilisation : le résumé ne peut pas être rédigé. Demandez à un administrateur de l'espace de travail d'acheter des crédits, ou attendez vos crédits mensuels inclus.",
noCreditsOnDevice: "Plus de crédits d'utilisation : le résumé ne peut pas être rédigé. Les crédits s'achètent sur AssetWRX sur le web, ou arrivent avec vos crédits mensuels inclus.",
topUp: "Acheter des crédits",
},
valueAnswer: {
readingLabel: "Relevé",
textLabel: "Réponse",
textPlaceholder: "Saisir ou scanner",
scan: "Scanner",
detected: "Détecté : {{value}}",
detectedOnDevice: "Lu sur cet appareil, aucun crédit IA utilisé",
use: "Utiliser",
ignore: "Ignorer",
},
checklistEditor: {
required: "Obligatoire",
yes: "Oui",
no: "Non",
ratingReading: "Relevé",
ratingText: "Texte",
meterLabel: "Compteur",
meterHintMissing: "Choisissez de quel compteur il s’agit. Ce n’est qu’alors que le relevé est ajouté à l’historique du compteur de l’actif à la fin de l’inspection.",
meterHintUnit: "Indiquez l’unité (par exemple bar ou °C) pour que le relevé puisse être ajouté à l’historique du compteur de l’actif.",
meterHintSaved: "Ajouté aux relevés « {{meter}} » de l’actif à la fin de l’inspection, et pris en compte pour la maintenance basée sur les compteurs.",
meterHours: "Heures",
meterDistance: "Distance",
meterCycles: "Cycles",
meterOther: "Autre",
unitLabel: "Unité",
visionCanAssist: "Vision peut répondre à partir d’une photo",
useVision: "Scanner cette section avec Vision",
visionOff: "Désactivé",
visionAvailable: "Disponible",
visionRecommended: "Recommandé",
evidenceAlways: "Photo attendue",
evidenceOnFail: "Photo attendue en cas d’échec",
measureLabel: "Mesure",
ratingCondition: "État",
ratingLevel: "Niveau",
ratingYesNo: "Oui/Non",
ratingPassFailNa: "Réussite/Échec/N/A",
ratingPassFlagFail: "Réussite/À signaler/Échec",
failWhenLabel: "Échec si",
yesNoFailHint: "Utilisez Oui pour les questions qui signalent un problème (par exemple « Des fissures ? »). Utilisez Non pour les questions de conformité (par exemple « La protection est-elle installée ? »).",
captureLabel: "Capture",
images: "Images",
videos: "Vidéos",
groupNameA11y: "Nom du groupe",
groupNamePlaceholder: "Nom du groupe",
itemLabelA11yIndexed: "Libellé de l’élément {{index}}",
itemLabelPlaceholder: "Libellé de l’élément",
itemDescriptionA11yIndexed: "Description de l’élément {{index}} (facultatif)",
descriptionOptionalPlaceholder: "Description (optionnel)",
addItemToGroup: "Ajouter un élément au groupe",
moveUpA11y: "Monter",
moveDownA11y: "Descendre",
removeGroupA11y: "Supprimer le groupe",
removeItemA11y: "Supprimer l’élément",
dragA11y: "Réorganiser : appuyez longuement, puis faites glisser",
itemLabelA11y: "Libellé de l’élément",
itemLabelPlaceholderExample: "Libellé de l’élément (par ex. Vérifier l’huile moteur)",
itemDescriptionA11y: "Description de l’élément (facultatif)",
requiredNeedsOneItem: "Une liste de contrôle nécessite au moins un élément.",
groupDefaultLabel: "Groupe {{number}}",
inspectionNotFoundTitle: "Inspection introuvable",
couldNotLoadItemsBody: "Impossible de charger cette inspection pour copier les éléments.",
noItemsToCopyTitle: "Aucun élément à copier",
noItemsToCopyBody: "Cette inspection ne comporte aucun élément de liste de contrôle à utiliser comme check-list.",
couldNotLoadInspectionTitle: "Impossible de charger l'inspection",
tryAgainOrCreateManually: "Réessayez ou créez la check-list manuellement.",
workflowCopySuffix: "{{name}} (copie du flux de travail)",
unsavedTemplateMessage: "Ce check-list n'a pas encore été enregistré. Partir et le perdre ?",
    unsavedEditsMessage: "Cette liste a des modifications non enregistrées. Quitter et les perdre ?",
    createFailed: "Impossible de créer la liste.",
    updateFailed: "Impossible de mettre à jour la liste.",
unsavedTemplateEditMessage: "Ce check-list comporte des modifications non enregistrées. Partir et les perdre ?",
templateNameLabel: "Nom du check-list *",
templateNameA11y: "Nom du check-list (obligatoire)",
templateNamePlaceholder: "par ex. Inspection de voiture avant achat",
generateDraft: "Générer un brouillon",
templateDetailsTitle: "Détails et visibilité de la check-list",
templateDetailsSummary: "Compatibilité des actifs, description, catégories et visibilité de l'équipe.",
assetTypeCompatibility: "Compatibilité des types d’actifs",
assetTypeHint: "Sélectionnez un type d'actif auquel cette check-list s'applique. Laissez vide pour n’importe quel type.",
customTypesLabel: "Vos types d’actifs",
customTypesHint: "Choisissez des types pour n’utiliser cette check-list que pour eux. Laissez vide pour tous les actifs de la catégorie ci-dessus.",
placeTypesLabel: "Types de lieu",
placeTypesHint: "Choisissez des types de lieu, comme Pièce, pour n’utiliser cette check-list que là. Laissez vide pour tous les lieux.",
any: "Tous",
visibilityLabel: "Visibilité",
visibilityAllTeams: "Toutes les équipes du compte peuvent utiliser cette check-list",
visibilityOnlySelectedTeams: "Uniquement les équipes sélectionnées (par défaut : votre équipe actuelle)",
visibilityCreateTeamHint: "Créer une équipe dans le compte pour restreindre la visibilité",
descriptionHint: "Bref résumé lors de la sélection de cette check-list. Facultatif.",
descriptionPlaceholderExample: "p. ex. Contrôle avant achat d'un véhicule",
categoriesLabel: "Catégories",
categoriesHint: "Sélectionnez une ou plusieurs catégories",
checklistItemsTitle: "Éléments de la checklist",
addGroup: "Ajouter un groupe",
addItem: "Ajouter un élément",
saveChecklist: "Enregistrer la liste de contrôle",
templateStructureTitle: "Structure de la check-list",
evidenceCoverageTitle: "Couverture des preuves",
evidenceCoverageCopy_one: "{{count}} élément capture actuellement au moins un type de preuve.",
evidenceCoverageCopy_other: "{{count}} éléments capturent actuellement au moins un type de preuve.",
versioningTitle: "Versions",
versioningCopy: "Vos modifications sont enregistrées comme une nouvelle version. Les inspections déjà commencées gardent la liste avec laquelle elles ont démarré.",
newTemplateTitle: "Nouveau check-list",
templateNotFound: "Check-list introuvable",
loadingTemplate: "Chargement de la check-list…",
startTemplateTitle: "Démarrez votre check-list",
startTemplateBody: "Ajoutez le premier élément ou groupe que votre inspecteur doit parcourir. Ou utilisez l'IA pour générer un brouillon.",
addFirstItem: "Ajoutez votre premier élément",
addAGroup: "Ajouter un groupe",
validationTitle: "Validation",
failedToCreateChecklist: "Échec de la création de la liste de contrôle.",
failedToUpdateChecklist: "Échec de la mise à jour de la liste de contrôle.",
editTemplateTitle: "Modifier le check-list",
saveChanges: "Enregistrer les modifications",
evidenceCoverageCopy_many: "{{count}} éléments capturent actuellement au moins un type de preuve.",
},
checklistDetail: {
loadErrorTitle: "Impossible de charger cette check-list",
categoryGeneral: "Général",
versionLabel: "Version v{{version}}",
updatedDate: "Mise à jour {{date}}",
currentVersionIdLabel: "ID de la version actuelle :",
versionIdNotSet: "Non défini",
assetTypesLabel: "Types d'actifs :",
allAssetTypesShort: "Tous",
scopeLabel: "Portée :",
versionRowLabel: "Version :",
versionRowValue: "v{{version}}",
createdRowLabel: "Créé :",
updatedRowLabel: "Mis à jour :",
selectedTeamsOnly: "Équipes sélectionnées uniquement",
structureLabel: "Structure :",
groupsCount_one: "{{count}} groupe",
groupsCount_other: "{{count}} groupes",
itemsCount_one: "{{count}} élément",
itemsCount_other: "{{count}} éléments",
requiredCountSuffix_one: ", {{count}} requis",
requiredCountSuffix_many: ", {{count}} requis",
requiredCountSuffix_other: ", {{count}} requis",
useTemplateForInspectionA11y: "Utiliser une check-list pour l'inspection",
itemsCountTitle: "Éléments · {{count}}",
required: "Obligatoire",
ungrouped: "Non groupé",
groupsCount_many: "{{count}} groupes",
itemsCount_many: "{{count}} éléments",
},
suggestScreen: {
  partialCreatedBody_other: "{{count}} interventions sur {{total}} créées. Impossible de créer « {{title}} ». Réessayez.",
  partialCreatedBody_many: "{{count}} interventions sur {{total}} créées. Impossible de créer « {{title}} ». Réessayez.",
  partialCreatedBody_one: "{{count}} intervention sur {{total}} créée. Impossible de créer « {{title}} ». Réessayez.",
  linkFailed_other: "{{count}} interventions créées, mais impossible de les ajouter à la demande. Réessayez.",
  linkFailed_many: "{{count}} interventions créées, mais impossible de les ajouter à la demande. Réessayez.",
  linkFailed_one: "Intervention créée, mais impossible de l’ajouter à la demande. Réessayez.",
  missingInspectionBody: "Revenez en arrière et rouvrez l’inspection.",
  partialCreatedTitle: "Certaines interventions n’ont pas été créées",
suggestedJobA11y: "Intervention suggérée {{title}}",
findingsCount_one: "{{count}} constat",
findingsCount_other: "{{count}} constats",
missingTitleOrCategory: "Manquant : titre ou catégorie",
editSuggestedJobTitle: "Modifier l'intervention suggérée",
titlePlaceholderRepairPipe: "par ex. Réparer un tuyau qui fuit",
scopeOfWorkPlaceholder: "Portée des travaux",
whereJobCarriedOutPlaceholder: "Où cette intervention sera-t-elle exécutée ?",
assignToRecommendedA11y: "Attribuer à {{name}}",
suggestedAssigneeLabel: "Suggéré : {{name}} · {{rationale}}",
workPathLabel: "Mode de traitement",
missingInspection: "Inspection manquante",
loadingEllipsis: "Chargement…",
accessRestrictedTitle: "Accès restreint",
accessRestrictedBody: "Seul le créateur de l'inspection ou un membre de l'équipe de l'actif peut créer des interventions à partir de ces éléments ayant échoué.",
accessDeniedAlertTitle: "Accès refusé",
accessDeniedAlertBody: "Seul le créateur de l'inspection ou l'équipe chargée des actifs peut créer ces interventions.",
selectSuggestedJobsTitle: "Sélectionnez les interventions suggérées",
selectSuggestedJobsBody: "Sélectionnez au moins une suggestion à créer.",
missingDetailsBodySuggest: "Il manque un titre ou une catégorie dans certaines suggestions sélectionnées. Modifiez ces cartes avant de créer des interventions.",
jobsAlreadyCreated: "Interventions déjà créées",
noSuggestedJobs: "Aucune intervention suggérée",
allFindingsLinkedBody: "Chaque constatation échouée ou marquée en réparation lors de cette inspection est déjà associée à une intervention.",
noFailedItemsBody: "Cette inspection ne contient actuellement aucun élément en échec ou marqué pour réparation qui nécessite une intervention de suivi.",
openReport: "Ouvrir le rapport",
linkedJobsTitle: "Interventions liées",
linkedJobsHintCannotRecreate: "Ces résultats sont déjà liés aux interventions et ne peuvent pas être recréés à moins que l'intervention soit supprimée.",
assetFallback: "Actif",
suggestionsCountPill_one: "{{count}} suggestion",
suggestionsCountPill_many: "{{count}} suggestions",
suggestionsCountPill_other: "{{count}} suggestions",
fromFailedItemsPill_one: "à partir de {{count}} élément en échec",
fromFailedItemsPill_many: "à partir de {{count}} éléments en échec",
fromFailedItemsPill_other: "à partir de {{count}} éléments en échec",
alreadyCreatedTitle: "Déjà créé",
linkedFindingsHint_one: "{{count}} constat a déjà une intervention liée et ne sera plus suggéré.",
linkedFindingsHint_many: "{{count}} constats ont déjà des interventions liées et ne seront plus suggérés.",
linkedFindingsHint_other: "{{count}} constats ont déjà des interventions liées et ne seront plus suggérés.",
followUpJobsFromMarkedItems: "Interventions issues des points en échec",
aiDraftedHint: "Rédigé par l’IA. Décochez ce qui ne doit pas devenir une intervention.",
ruleBasedHint: "Décochez ce qui ne doit pas devenir une intervention.",
progressLinkNeedsAttention: "Non ajouté à la demande",
progressLinkMessage: "L'intervention a été créée, mais la progression de la demande/du rapport partagé n'a pas été mise à jour. {{message}}",
retryLink: "Réessayer",
stillNotLinkedTitle: "Toujours pas lié",
jobCreatedNotLinkedFallback: "L’intervention a été créée mais n’a pas pu être liée à l’enregistrement d’avancement partagé.",
unableToLinkJobFallback: "Impossible de lier l'intervention à la demande.",
missingDetailsBanner_one: "{{count}} suggestion sélectionnée nécessite un titre ou une catégorie avant de pouvoir créer des interventions. Les compétences sont recommandées mais facultatives pour les interventions suggérées.",
missingDetailsBanner_other: "{{count}} suggestions sélectionnées nécessitent un titre ou une catégorie avant de pouvoir créer des interventions. Les compétences sont recommandées mais facultatives pour les interventions suggérées.",
createJobsA11y_one: "Créer {{count}} intervention suggérée",
createJobsA11y_many: "Créer {{count}} interventions suggérées",
createJobsA11y_other: "Créer {{count}} interventions suggérées",
creatingEllipsisEn: "Création...",
createJobsButton_one: "Créer {{count}} intervention",
aiDraft: {
  button: "Rédiger avec l’IA",
  again: "Rédiger à nouveau avec l’IA",
  notEnough: "Crédits IA insuffisants",
  failedTitle: "La rédaction par IA a échoué",
  failedBody: "Votre liste est inchangée. Veuillez réessayer.",
},
createAndAssignButton_one: "Créer et attribuer {{count}} intervention",
createAndAssignButton_other: "Créer et attribuer {{count}} interventions",
createAndAssignButton_many: "Créer et attribuer {{count}} interventions",
approvedBy: "Approuvé par {{name}}",
handOverIncompleteTitle: "Créées, pas toutes transmises",
handOverIncompleteBody: "Les interventions existent, mais celles-ci n’ont pas été transmises ou le prestataire n’a pas été prévenu : {{names}}. Ouvrez chacune pour terminer.",
createJobsButton_other: "Créer {{count}} interventions",
findingsCount_many: "{{count}} constats",
missingDetailsBanner_many: "{{count}} suggestions sélectionnées nécessitent un titre ou une catégorie avant de pouvoir créer des interventions. Les compétences sont recommandées mais facultatives pour les interventions suggérées.",
createJobsButton_many: "Créer {{count}} interventions",
},
shareScreen: {
  askApproveSuggested_other: "Demander aussi l'approbation de {{count}} réparations suggérées",
  askApproveSuggested_many: "Demander aussi l'approbation de {{count}} réparations suggérées",
  askApproveSuggested_one: "Demander aussi l'approbation de {{count}} réparation suggérée",
  askApproveSuggestedHint: "La personne peut approuver ou refuser chacune.",
  relationshipChangeA11y: "Modifier son lien avec le bien",
  relationshipChange: "Modifier",
  relationship: "Son lien : {{role}}",
  greetingTemplateRepairs: "Bonjour,\n\nVoici le rapport d'inspection pour {{assetName}}. Ouvrez le lien pour le lire et appuyez sur Refuser pour chaque réparation proposée dont vous ne voulez pas. Puis signez pour valider, ou appuyez sur Renvoyer pour demander des modifications.\n\nMerci.",
greetingTemplate: "Bonjour,\n\nVoici le rapport d'inspection pour {{assetName}}. Ouvrez le lien pour le lire, puis signez pour valider, ou appuyez sur Renvoyer pour demander des modifications.\n\nMerci.",
assetFallback: "votre actif",
emailNotSent: "Partagé, mais l'e-mail n'a pas été envoyé. Copiez le lien pour l'envoyer vous-même.",
copyLink: "Copier le lien",
shareCreatedTitle: "Partage créé",
shareThisLinkBody: "Partager ce lien :\n{{link}}",
inspectionNotFound: "Inspection introuvable.",
contactNeedsEmail: "Ajoutez son adresse e-mail pour envoyer le rapport par e-mail.",
checkEmailAddress: "Vérifiez l’adresse e-mail : elle ne semble pas valide.",
checkPhoneNumber: "Vérifiez le numéro de téléphone : saisissez un numéro valide pour le pays sélectionné ou laissez-le vide.",
reportResentNotify: "Rapport envoyé à nouveau. Vous êtes prévenu à sa réponse.",
reportSharedNotify: "Rapport envoyé. La personne reçoit un e-mail avec un lien, et vous êtes prévenu à sa réponse.",
createShareFailedFallback: "Échec de la création du partage.",
errorTitle: "Erreur",
requiredTitle: "Obligatoire",
enterEmailRequired: "Veuillez saisir une adresse e-mail (ou sélectionner un contact avec un e-mail).",
recipientFallback: "Destinataire",
contactFallback: "Contact",
selectContactTitle: "Sélectionnez un contact",
selectContactBody: "Le partage est basé sur les contacts. Veuillez appuyer sur « Sélectionner le contact » et choisir ou ajouter un contact avec lequel partager.",
respondByLine: "Veuillez répondre avant le {{date}}\n\n",
estimatedTotalLine: "Total estimé : {{amount}}\n\n",
reviewLinkLine: "Lien de révision : {{link}}",
assetFallbackShort: "Actif",
emailSubject: "Rapport d'inspection – {{assetName}}",
resentTitle: "Renvoyé",
sentTitle: "Envoyé",
resentBody: "Rapport d'inspection renvoyé au destinataire.",
sentBody: "Rapport d'inspection partagé. Le destinataire sera informé.",
deliveryUnconfirmed: "Le partage a été créé, mais la livraison n’a pas pu être confirmée. Partagez ce lien manuellement :\n{{link}}",
inspectionNotFoundPlain: "Inspection introuvable",
onlyCreatorAssigneeOrTeamCanShare: "Seul le créateur de cette inspection, son inspecteur désigné ou un membre de l'équipe de l'actif peut partager le rapport.",
shareLinkNotConfiguredProd: "Aucun lien Web partageable n'est encore configuré pour cet espace de travail. Les destinataires risquent de ne pas pouvoir ouvrir le lien du rapport. Veuillez contacter votre administrateur.",
reviewAssistantTitle: "Assistant de relecture",
sending: "Envoi…",
resendReportTo: "Renvoyer le rapport à {{name}}",
sendReportTo: "Envoyer le rapport à {{name}}",
theRequesterFallback: "le demandeur",
oneTapHint: "Rempli à partir de la demande. Modifiez la personne ou le message ci-dessous si besoin.",
shareTo: "Envoyer à",
contactsHint: "Appuyez sur Sélectionner le contact et choisissez la personne. Les personnes à qui vous l'avez déjà envoyé sont en haut.",
whoCanOpen: "Seule cette personne peut ouvrir le rapport. Le lien de son e-mail la connecte directement. Toute autre personne qui reçoit le lien peut seulement vous demander l'accès.",
changeContact: "Changer le contact",
selectContact: "Sélectionner le contact",
primaryChooseRole: "Choisir un rôle",
primaryAddEmail: "Ajouter un e-mail",
primaryResend: "Envoyer à nouveau",
primarySend: "Envoyer le rapport",
noEmailOrPhone: "Pas d'e-mail ni de téléphone",
shareToContactTitle: "Envoyer à",
howToSend: "Comment envoyer",
byEmail: "Par e-mail",
roleLabel: "Rôle *",
recipientNameOptional: "Son nom (facultatif)",
recipientNamePlaceholder: "par ex. John Smith",
recipientEmailLabel: "Son e-mail *",
recipientEmailA11y: "Son e-mail (obligatoire)",
recipientEmailPlaceholder: "client@exemple.com",
phoneOptional: "Téléphone (facultatif)",
shareStatus: "Déjà envoyé",
firstSharedLabel: "Déjà envoyé le {{date}}",
lastResharedLabel: "Envoyé à nouveau le {{date}}",
noResponseByDeadline: "Pas de réponse à la date prévue. Appuyez sur Envoyer à nouveau pour relancer.",
responseDeadlineOptional: "Répondre avant le (facultatif)",
messageOptional: "Message (facultatif)",
messagePlaceholder: "Ajouter une note pour le destinataire...",
includeSuggestedJobsTitle: "Inclure les interventions suggérées dans la révision partagée",
includeSuggestedJobsHint_one: "Ajoute {{count}} élément de suivi suggéré pour approbation par le destinataire.",
includeSuggestedJobsHint_other: "Ajoute {{count}} éléments de suivi suggérés pour approbation par le destinataire.",
missingEstimateWarning_one: "{{count}} élément n'a pas d'estimation de coût — il figurera quand même dans le rapport, mais sans coût. Vous pouvez partager maintenant ou ajouter des estimations d'abord.",
missingEstimateWarning_other: "{{count}} éléments n’ont pas d’estimation de coût — ils figureront quand même dans le rapport, mais sans coût. Vous pouvez partager maintenant ou ajouter des estimations d’abord.",
couldNotShareReportTitle: "Impossible de partager le rapport",
sharingFailedFallback: "Échec du partage. Vérifiez votre connexion et réessayez.",
includeSuggestedJobsHint_many: "Ajoute {{count}} éléments de suivi suggérés pour approbation par le destinataire.",
missingEstimateWarning_many: "{{count}} éléments n’ont pas d’estimation de coût — ils figureront quand même dans le rapport, mais sans coût. Vous pouvez partager maintenant ou ajouter des estimations d’abord.",
},
reportScreen: {
  exportFailed: {
    word: "Impossible de créer le fichier Word. Réessayez.",
    excel: "Impossible de créer le fichier Excel. Réessayez.",
    pdf: "Impossible de créer le PDF. Réessayez.",
  },
  exportPreparing: {
    word: "Préparation du fichier Word…",
    excel: "Préparation du fichier Excel…",
    pdf: "Préparation du PDF…",
  },
editRepairDetailsTitle: "Modifier les détails de la réparation",
saveFailedFallback: "Échec de l'enregistrement.",
titleLabel: "Titre",
titlePlaceholder: "par ex. Réparer le robinet qui fuit",
categoryLabel: "Catégorie",
descriptionLabel: "Description",
descriptionPlaceholder: "Que faut-il faire...",
priorityLabel: "Priorité",
dueDateOptional: "Date d’échéance (facultatif)",
estimatedCostOptional: "Coût estimé (facultatif)",
estimatedCostA11y: "Montant du coût estimé",
visibilityLabel: "Visibilité",
saveRepairFailedTitle: "Impossible d'enregistrer la réparation",
syncFailedGeneric: "La synchronisation a échoué.",
skipped: "Ignoré",
downloadPdf: "Télécharger PDF",
downloadExcel: "Télécharger Excel",
downloadWord: "Télécharger Word",
sharePdfToGoogleDrive: "Partager PDF sur Google Drive…",
shareExcelToOneDrive: "Partager Excel sur OneDrive…",
shareWordToSharePoint: "Partager Word sur SharePoint…",
googleDrive: "Google Drive",
oneDrive: "OneDrive",
sharePoint: "SharePoint",
shareRequiredTitle: "Partagez d’abord le rapport",
shareRequiredBody: "Touchez Partager et choisissez le destinataire. Cela crée le lien qu’il ouvrira pour le lire et y répondre.",
hostedLinkCopiedTitle: "Lien de relecture copié",
inspectionReportFileLabel: "Rapport d'inspection ({{format}})",
exportFileError: "Impossible de générer le fichier d'exportation.",
exportReadyTitle: "Export prêt",
exportReadyBody: "Le téléchargement de votre fichier a commencé.",
reportInsightTitle: "Aperçu du rapport",
reviewRepairEvidenceAction: "Examinez les preuves de réparation et le coût estimé avant l'exportation.",
shareReportAction: "Touchez Partager pour envoyer un lien qui permet de lire le rapport et d’y répondre.",
runFirstExportAction: "Touchez Télécharger pour enregistrer une copie PDF, Excel ou Word avec votre logo.",
itemsVisible_one: "{{count}} élément d'inspection est visible dans le rapport.",
itemsVisible_other: "{{count}} éléments d'inspection sont visibles dans le rapport.",
repairFindingsIncluded_one: "{{count}} constat de réparation est inclus.",
repairFindingsIncluded_other: "{{count}} constats de réparation sont inclus.",
noRepairFindingsIncluded: "Aucun constat de réparation n'est inclus.",
hostedLinkAvailable: "Un lien de relecture est prêt à être envoyé.",
hostedLinkNotAvailable: "Pas encore de lien de relecture. Touchez Partager pour en créer un.",
exportRecords_one: "{{count}} enregistrement d'exportation récent existe.",
exportRecords_other: "{{count}} enregistrements d’exportation récents existent.",
noExportActivity: "Personne n’a encore téléchargé ce rapport.",
metricInspected: "Inspecté",
metricRepairs: "Réparations",
metricExports: "Exportations",
metricSummary: "Résumé",
summaryReady: "Prêt",
summaryMissing: "Manquant",
insightSourceLabel: "éléments et réparations de cette inspection",
nextSteps: "Prochaines étapes",
copyHostedReportLink: "Copier le lien de relecture",
brandingSettings: "Paramètres de l’image de marque",
moreReportOptionsA11y: "Plus d'options de rapport",
yourSignOff: "Votre validation",
signOff: "Valider",
reviewAndSignOff: "Approuver ou renvoyer",
shareA11y: "Partager",
share: "Partager",
assignedTo: "Assigné à {{name}}",
unassigned: "Non assigné",
quoteAwarded: "Devis retenu",
quoteRequested: "Devis demandé",
quotes: "Devis",
jobsCreated_one: "{{count}} intervention créée",
jobsCreated_other: "{{count}} interventions créées",
findingsMayNeedJobs_one: "{{count}} constat peut nécessiter des interventions",
findingsMayNeedJobs_other: "{{count}} constats peuvent nécessiter des interventions",
noRepairFindingsInReport: "Aucune constatation de réparation dans ce rapport",
createJobsFromFindingsA11y: "Confirmer les interventions issues des constats",
createJobsFromFindings: "Confirmer les interventions",
openLinkedJobsA11y: "Ouvrir des interventions liées",
openLinkedJobs_one: "Ouvrir l'intervention liée",
openLinkedJobs_other: "Ouvrir des interventions liées",
approved: "Validée",
awaitingApproval: "En attente de validation",
approvedBy: "Validée par {{name}}",
recipientFallback: "destinataire",
approvedOnAt: " le {{date}} à {{time}}",
reviewRequested: "Validation demandée",
sharedWithName: "Partagé avec {{name}}",
reviewRequestedFallback: "avis demandé",
firstShared: "Premier envoi {{date}}",
lastReshared: " | Dernier partage {{date}}",
resendAndUpdateDeadline: "Renvoyer et mettre à jour l’échéance",
noReviewRequestedYet: "Aucun avis n'a encore été demandé.",
notSharedYetPrefix: "Pas encore partagé — utilisez ",
shareAboveLink: "Partager ci-dessus",
notSharedYetSuffix: " pour demander un examen.",
theInspectorFallback: "l'inspecteur",
askInspectorEmptyHint: "Interrogez l'inspecteur à propos de ce rapport. Aucun message pour l'instant.",
discussInspectionEmptyHint: "Discutez de cette inspection avec l'examinateur. Aucun message pour l'instant.",
atAGlance: "En un coup d'œil",
estTotal: "Total est.",
approvalLabel: "Validation",
approvalAwaiting: "En attente",
jobsLabel: "Interventions",
recentExports: "Exportations récentes",
loadingExportHistory: "Chargement de l'historique des exportations...",
noExportsRecorded: "Aucune exportation enregistrée pour ce rapport.",
loadErrorTitle: "Impossible de charger ce rapport",
goBack: "Retour",
reportAvailableWhenCompleted: "Rapport disponible une fois l’inspection terminée.",
findingsAndEvidence: "Résultats et preuves",
noItemsRecorded: "Aucun élément d'inspection n'a été enregistré pour cette inspection.",
otherGroup: "Autre",
inspectorNotes: "Notes de l’inspecteur",
noteLabel: "Note",
itemSkippedFallback: "Cet élément a été ignoré lors de l'inspection.",
mediaCount: "Médias · {{count}}",
playVideo: "Lire la vidéo {{index}}",
repairAndRemediation: "Réparation et remise en état",
descriptionOrRecommendation: "Description",
recommendation: "Recommandation",
labourAndMaterials: "Main d’œuvre et matériaux",
urgentFallback: "Urgent",
requiredSkills: "Compétences requises",
dueDate: "Date d'échéance",
estimatedCost: "Coût estimé",
urgentRepairNote: "Note de réparation urgente",
urgentRepairNoteFallback: "Cet élément a été signalé comme nécessitant une attention urgente.",
jobCreated: "Intervention créée",
jobsCreatedPlain: "Interventions créées",
editRepairDetails: "Modifier les détails de la réparation",
whereThisStands: "Où en sommes-nous",
reportOptionsTitle: "Options de rapport",
couldNotLoadImageSubtext: "L'image a peut-être été déplacée ou n'est pas disponible.",
syncReportWorkspaceFailedTitle: "Impossible de créer le fichier",
statusPrefix: "Statut : {{status}}",
templateVersionLabel: "Check-list : {{name}}{{version}}",
conductedInspection: "Inspection effectuée",
inspectorFallback: "Inspecteur",
itemsVisible_many: "{{count}} éléments d'inspection sont visibles dans le rapport.",
repairFindingsIncluded_many: "{{count}} constats de réparation sont inclus.",
exportRecords_many: "{{count}} enregistrements d’exportation récents existent.",
jobsCreated_many: "{{count}} interventions créées",
findingsMayNeedJobs_many: "{{count}} constats peuvent nécessiter des interventions",
openLinkedJobs_many: "Ouvrir des interventions liées",
},
convertScreen: {
  missingShareBody: "Ouvrez cette page depuis le rapport d’inspection pour transformer les réparations approuvées en interventions.",
  missingShareTitle: "Rien à ouvrir ici",
editA11y: "Modifier {{title}}",
dueLabel: "Échéance le {{date}}",
missingFieldsHint: "Manquant : titre, catégorie ou compétences requises",
editJobDetailsTitle: "Modifier les détails de l'intervention",
requiredTitle: "Obligatoire",
requiredBody: "Le titre et la catégorie sont requis.",
titleLabel: "Titre",
titlePlaceholder: "par ex. Réparer le robinet qui fuit",
categoryLabel: "Catégorie *",
priorityLabel: "Priorité (facultatif)",
dueDateLabel: "Date d’échéance (facultatif)",
jobLocationLabel: "Emplacement de l'intervention (facultatif)",
addressSearchPlaceholder: "Rechercher une adresse…",
estimateLabel: "Estimation (facultatif)",
costPlaceholder: "0,00",
assigneeLabel: "Responsable (facultatif)",
noneOption: "Aucun",
saving: "Enregistrement…",
save: "Enregistrer",
missingShare: "Partage manquant",
loading: "Chargement...",
noApprovedRepairsTitle: "Aucune réparation approuvée",
noApprovedRepairsBody: "Le client n'a encore approuvé aucune réparation pour ce partage.",
onlyCreatorOrTeamCanConvert: "Seul le créateur de l'inspection ou un membre de l'équipe de l'actif peut créer des interventions à partir de ce partage.",
unsavedJobEditsMessage: "Vous avez des modifications d'intervention non enregistrées. Partir et les perdre ?",
leave: "Quitter",
keepEditing: "Continuer à modifier",
createJobsErrorTitle: "Impossible de créer les interventions",
createJobsErrorFallback: "Échec de la création des interventions.",
selectRepairsTitle: "Sélectionnez les réparations",
selectRepairsBody: "Sélectionnez au moins une réparation approuvée (cochez la case sur chaque carte). Appuyez sur une carte pour modifier le titre, la catégorie ou le responsable avant de créer.",
missingDetailsTitle: "Détails manquants",
missingDetailsBody: "Certaines réparations sélectionnées n'ont pas de titre, de catégorie ou de compétences requises. Appuyez sur chaque carte à modifier avant de créer des interventions.",
step1WorkPath: "Qui fera le travail ?",
step1WorkPathHint: "Choisissez votre équipe, un sous-traitant, ou demandez des devis. Vous choisirez les personnes une fois les interventions créées.",
step2SelectItems: "Quelles réparations ont besoin d’une intervention ?",
creatingJobs: "Création en cours…",
createJobs_one: "Créer {{count}} intervention",
createJobs_other: "Créer {{count}} interventions",
createJobs_many: "Créer {{count}} interventions",
},
completeScreen: {
  approvedToast: "Inspection validée. Partagez le rapport ou choisissez Terminé.",
  alerts: {
    optionalBody_other: "{{count}} éléments facultatifs ne sont ni renseignés ni ignorés. Terminer quand même ?",
    optionalBody_many: "{{count}} éléments facultatifs ne sont ni renseignés ni ignorés. Terminer quand même ?",
    optionalBody_one: "{{count}} élément facultatif n’est ni renseigné ni ignoré. Terminer quand même ?",
    failedTitle_other: "{{count}} éléments en échec n’ont ni photo ni note",
    failedTitle_many: "{{count}} éléments en échec n’ont ni photo ni note",
    failedTitle_one: "{{count}} élément en échec n’a ni photo ni note",
    requiredBody_other: "Répondez à {{count}} éléments obligatoires ou ignorez-les avant de terminer cette inspection.",
    requiredBody_many: "Répondez à {{count}} éléments obligatoires ou ignorez-les avant de terminer cette inspection.",
    requiredBody_one: "Répondez à {{count}} élément obligatoire ou ignorez-le avant de terminer cette inspection.",
    completedToast: "Inspection terminée",
    optionalTitle: "Éléments sans réponse",
    goToFailed: "Aller à l’élément en échec",
    failedBody: "Ajoutez une photo ou une note pour montrer le problème, ou terminez en l’état.",
    jumpToFirst: "Aller au premier",
    requiredTitle: "Éléments obligatoires non faits",
    tryAgain: "Réessayer",
    savingBody: "Elles sont conservées sur cet appareil. Touchez Réessayer, puis terminez l’inspection.",
    savingTitle: "Certaines réponses ne sont pas encore enregistrées",
    conflictChoose: "Choisir",
    conflictBody: "Choisissez Garder mes réponses ou Utiliser les leurs, puis terminez.",
    conflictTitle: "Quelqu’un d’autre a modifié cette inspection",
  },
  status: {
    nextVisit: "Prochaine visite prévue le {{date}}.",
    requesterWaiting: "Le demandeur attend ce rapport.",
    sentTo: "Envoyée à {{name}} pour approbation.",
    approveSelf: "Vérifiez les constats, puis touchez Valider.",
    approveOrLeave: "Validez-la vous-même, ou laissez-la à {{name}}.",
  },
  actions: {
    approve: "Valider",
    createCertificate: "Émettre le certificat renouvelé",
    shareRequester: "Partager le rapport avec le demandeur",
    createApprovedJobs: "Créer les interventions approuvées",
    scheduleNext: "Planifier la prochaine inspection",
    shareReport: "Partager le rapport",
    exportReport: "Exporter le rapport",
    report: "Rapport",
    done: "Terminé",
    confirmJobs: "Confirmer les interventions",
  },
loadErrorTitle: "Impossible de charger cette inspection",
loadErrorDescription: "Vérifiez votre connexion et réessayez.",
notFoundTitle: "Inspection introuvable",
notFoundDescription: "Cette inspection a peut-être été supprimée ou le lien est obsolète.",
goBack: "Retour",
notCompletedYet: "Cette inspection n’est pas encore terminée.",
back: "Retour",
generateSummaryError: "Impossible de générer le résumé de l'inspection. Veuillez réessayer.",
saveSummaryError: "Impossible d'enregistrer le résumé de l'inspection. Veuillez réessayer.",
reopenErrorTitle: "Impossible de rouvrir",
reopenErrorFallback: "Veuillez réessayer.",
jobFollowUpTitle: "Suivi {{name}}",
jobFollowUpDescription: "Suite de l’inspection {{checklist}} de {{assetName}}, le {{date}}.",
assetFallback: "actif",
templateFallback: "Inspection",
certificateTitle: "Certificat {{name}}",
cannotCreateCertificateTitle: "Impossible de créer un certificat",
cannotCreateCertificateBody: "Cette inspection n'est pas liée à un bien.",
certificateCreatedTitle: "Certificat créé",
certificateCreatedBody: "Certificat enregistré dans les Documents de l’actif.",
errorTitle: "Impossible de créer le certificat",
certificateCreateError: "Impossible de créer le certificat.",
inspectedLabel: "Inspecté",
failedItemsLabel: "Éléments ayant échoué",
followUpJobsLabel: "Interventions suggérées",
inspectionAssistantTitle: "Assistant d'inspection",
confirmNextActions: "La suite",
moreCompletionActions: "Plus",
moreCompletionActionsSummary: "Créer une intervention à la main, rouvrir l’inspection ou partager le rapport.",
createJobNow: "Créer une intervention maintenant",
notifyTeam: "Notifier l'équipe",
syncFailedTitle: "Impossible d’enregistrer le résumé",
syncFailedFallback: "L’envoi a échoué. Vérifiez votre connexion et réessayez.",
},
templateCard: {
allAssetTypes: "Tous les types d'actifs",
categoryGeneral: "Général",
categoriesCount_one: "{{count}} catégorie",
categoriesCount_many: "{{count}} catégories",
categoriesCount_other: "{{count}} catégories",
usedCount_zero: "Pas encore utilisé",
usedCount_one: "Utilisé {{count}} fois",
usedCount_many: "Utilisé {{count}} de fois",
usedCount_other: "Utilisé {{count}} fois",
createdDate: "Créé {{date}}",
allTeams: "Toutes les équipes",
selectedTeams: "Équipes sélectionnées",
},
checklistCard: {
allTypes: "Tous les types",
shared: "Partagé",
totalItems: "Total des éléments",
required: "Obligatoire",
optional: "Facultatif",
usedTimes_one: "Utilisé {{count}} fois",
usedTimes_other: "Utilisé {{count}} fois",
completedCount_one: "{{count}} terminé",
completedCount_many: "{{count}} terminés",
completedCount_other: "{{count}} terminés",
estMinutes: "~{{count}} min",
createdDate: "Créé {{date}}",
usedTimes_many: "Utilisé {{count}} fois",
},
conditionalEditor: {
showOnlyWhen: "Afficher uniquement lorsque",
addPreviousItemFirst: "Ajoutez d'abord un élément précédent pour rendre cela conditionnel.",
parentItem: "Élément parent",
untitledItem: "Élément sans titre",
alwaysShown: "Toujours affiché",
expectedAnswer: "Réponse attendue",
notConditional: "Non conditionnel",
clearCondition: "Effacer la condition",
onlyShownWhen: "Affiché uniquement lorsque « {{parent}} » est {{value}}.",
conditionInvalidAfterReorder: "La condition actuelle n’est plus valable après la réorganisation. Choisissez un élément antérieur ou effacez-la.",
itemAlwaysShown: "Cet élément est toujours affiché.",
},
card: {
awaitingReviewerResponse: "En attente de réponse de l'évaluateur",
inspectorFallback: "Inspecteur",
recipientFallback: "Destinataire",
sharePendingCount_one: "{{count}} en attente",
sharePendingCount_many: "{{count}} en attente",
sharePendingCount_other: "{{count}} en attente",
shareDeclinedCount_one: "{{count}} refusé",
shareDeclinedCount_many: "{{count}} refusés",
shareDeclinedCount_other: "{{count}} refusés",
shareApprovedCount_one: "{{count}} approuvé",
shareApprovedCount_many: "{{count}} approuvés",
shareApprovedCount_other: "{{count}} approuvés",
sharedWith: "Partagé avec {{names}}",
responseDue: "Réponse due {{date}}",
templateFallback: "Inspection",
assetFallback: "Actif inconnu",
inspectorA11y: "Inspecteur {{name}}",
issuesCountA11y_one: "{{count}} problème",
issuesCountA11y_many: "{{count}} problèmes",
issuesCountA11y_other: "{{count}} problèmes",
repairsCountA11y_one: "{{count}} réparation",
repairsCountA11y_many: "{{count}} réparations",
repairsCountA11y_other: "{{count}} réparations",
urgentCountA11y_one: "{{count}} urgent",
urgentCountA11y_many: "{{count}} urgents",
urgentCountA11y_other: "{{count}} urgents",
openAssetA11y: "Ouvrir l’actif {{assetName}}",
urgentPill: "Urgent {{count}}",
issuesPill: "Problèmes {{count}}",
repairsPill: "Réparations {{count}}",
awaitingApproval: "En attente d'approbation",
sharedDense: "Partagé",
reportShared: "Rapport partagé",
},
noteSuggestions: {
suggestions: "Suggestions",
tapToInsert: "Appuyez pour insérer",
findingRecentNotes: "Recherche de notes récentes…",
},
/** The runner's item controls, footer and summary line (were English literals). */
runner: {
  skipGroupBody_other: "Marquer {{count}} éléments de ce groupe comme ignorés, puis passer au groupe suivant ?",
  skipGroupBody_many: "Marquer {{count}} éléments de ce groupe comme ignorés, puis passer au groupe suivant ?",
  skipGroupBody_one: "Marquer {{count}} élément de ce groupe comme ignoré, puis passer au groupe suivant ?",
  syncUnsavedBanner: "Une modification n’a pas été enregistrée. Touchez pour réessayer.",
  syncFailedBanner: "Certaines réponses ne sont pas encore enregistrées. Elles sont conservées sur cet appareil. Touchez pour réessayer.",
  tryAgain: "Veuillez réessayer.",
  moveToItemTitle: "Impossible d’aller à cet élément",
  captureUnsupported: "Ce type de capture ne peut pas être enregistré dans un élément.",
  captureScanBody: "Les codes QR sont lus par le scanner, pas enregistrés dans les éléments.",
  captureScanTitle: "Utilisez le scanner pour les codes QR",
  captureMeasurementAdded: "Mesure ajoutée à la note de l’élément.",
  captureMeasurement: "Mesure : {{value}}",
  captureNoteAdded: "Note ajoutée à l’élément.",
  capturePhotoAdded: "Photo ajoutée à l’élément.",
  captureNoNote: "Aucune note n’a été saisie.",
  captureNoPhoto: "Aucune photo n’a été prise.",
  capturePhotosOff: "Cet élément n’accepte pas de photos.",
  captureNoItem: "Ouvrez d’abord un élément, puis recommencez la capture.",
  captureMismatch: "Cette capture concerne une autre inspection.",
  captureNotFound: "Cette capture est introuvable. Recommencez la capture.",
  captureNotSavedTitle: "Capture non enregistrée",
  skipGroupReason: "Groupe sans objet",
  skipGroupConfirm: "Ignorer le groupe",
  skipGroupTitle: "Ignorer ce groupe ?",
  keysClose: "Fermer ce panneau",
  keysToggle: "Afficher ou masquer ce panneau",
  keysSkip: "Ignorer l’élément ouvert",
  keysYesNo: "Répondre Oui / Non (élément ouvert)",
  keysRate: "Répondre Réussi / Échec / S.O. (élément ouvert)",
  keysPrevNext: "Élément ou groupe précédent / suivant",
  timelineStatusScheduled: "Planifiée",
  timelineStatusCreated: "Créée",
  timelineAutomatic: "Automatique",
  timelineUpdated: "Dernière mise à jour",
  timelineCancelled: "Inspection annulée",
  timelineApproved: "Rapport approuvé",
  timelineCompleted: "Inspection terminée",
  timelineResumeScheduled: "Reprise planifiée",
  timelinePaused: "Inspection en pause",
  timelineStarted: "Inspection commencée",
  timelineCreated: "Inspection créée",
  exportReport: "Exporter le rapport",
  report: "Rapport",
  askAiDescription: "Obtenez de l’aide pour les prochaines vérifications, d’après vos réponses.",
  askAiTooltip: "L’IA peut vous aider pour les prochaines vérifications",
  askAi: "Demander à l’IA",
  saveAndExit: "Enregistrer et quitter",
  savedFindInWork: "Enregistré. Retrouvez-la dans Travail, sous À moi, pour continuer.",
  delete: "Supprimer",
  deleteBody: "Cette action est définitive.",
  deleteTitle: "Supprimer cette inspection ?",
  allItemsDone: "Tous les éléments sont faits. Touchez Terminer l’inspection.",
  sharedReportHint: "Si quelqu’un vous a partagé un rapport, ouvrez le lien de son e-mail. Vous pouvez aussi consulter Activité pour les rapports qui vous attendent.",
  requester: "Demandeur",
  fromRequest: "Issue d’une demande",
  unknownStatus: "Inconnu",
  itemsHidden: "{{total}} éléments ne s’appliquent plus et sont masqués.",
  itemHiddenOne: "« {{label}} » ne s’applique plus, il est donc masqué.",
  addNoteFirstBody: "Saisissez une courte note, puis touchez Peaufiner.",
  addNoteFirstTitle: "Ajoutez d’abord une note",
  signInVideos: "Connectez-vous pour ajouter des vidéos.",
  signInPhotos: "Connectez-vous pour ajouter des photos.",
  signInTitle: "Connexion requise",
  recordVideo: "Filmer ou choisir une vidéo",
  takePhoto: "Prendre ou choisir une photo",
  polishFailedTitle: "Impossible de peaufiner le texte",
  polishedTitle: "Texte peaufiné",
  discard: "Ignorer",
  editDraft: "Modifier",
  accept: "Accepter",
  revert: "Annuler la modification",
  draftNoteTitle: "Brouillon de note pour {{label}}",
  previousInspection: "Inspection précédente",
  previousRating: "Précédent : {{rating}}",
  previousNote: "La dernière fois : {{note}}",
  videoOfA11y: "Vidéo {{index}} sur {{total}}",
  photoOfA11y: "Photo {{index}} sur {{total}}",
  expandDetails: "Afficher les détails",
  collapseDetails: "Masquer les détails",
  collapsed: "réduit",
  expanded: "développé",
  stateNotCompletedShort: "non terminé",
  stateSkippedShort: "ignoré",
  stateCompletedShort: "terminé",
  itemHeaderA11y: "{{label}}, {{state}}, {{expanded}}",
  stateNotCompleted: "Non terminé",
  stateCompleted: "Élément terminé",
  stateSkipped: "Ignoré",
  followUpAddA11y: "Ajouter un suivi pour {{label}}",
  followUpEditA11y: "Modifier le suivi de {{label}}",
  flaggedNeedsJob: "Signalé. Faut-il une intervention ?",
  mediaAddA11y: "Ajouter une photo ou une vidéo pour {{label}}",
  mediaAttachedA11y: "Ajouter des preuves pour {{label}}, {{total}} jointes",
  noteAddA11y: "Ajouter ou dicter une note pour {{label}}",
  noteEditA11y: "Modifier la note de {{label}}",
  note: "Note",
  naA11y: "Sans objet",
  naSub: "Ne s’applique pas ici",
  na: "S.O.",
  flagSub: "À revoir",
  flag: "Signaler",
  failSub: "Ne répond pas aux critères",
  fail: "Échec",
  passSub: "Conforme aux critères d’inspection",
  pass: "Réussi",
media: "Médias",
followUp: "Suivi",
followUpProposed: "Intervention proposée",
yesOrNo: "Oui ou Non",
passFailNa: "Réussi, Échec ou N/A",
passFlagFail: "Réussi, Signaler ou Échec",
level: "Niveau",
conditionRating: "Évaluation de l'état",
stop: "Arrêter",
finishing: "Finalisation...",
dictate: "Dicter",
polishing: "Peaufinage…",
generating: "Génération…",
polish: "Peaufiner",
generateDraft: "Générer un brouillon",
previous: "Précédent",
completeInspection: "Terminer l'inspection",
nextItem: "Élément suivant",
lastItem: "Dernier élément",
nextGroup: "Groupe suivant",
lastGroup: "Dernier groupe",
nextUnanswered: "Prochain sans réponse",
started: "Commencée {{when}}",
startedBy: "Commencée {{when}} · {{name}}",
},
viewModel: {
completionHintBlocking: "Le bouton « Terminer l’inspection » apparaîtra une fois les éléments obligatoires renseignés ou ignorés.",
completionHintFinalGroup: "Le bouton « Terminer l’inspection » apparaîtra lorsque vous atteindrez le dernier groupe.",
completionHintLastItem: "Le bouton « Terminer l’inspection » apparaîtra sur le dernier élément.",
completionHintOptionalRemain: "Les éléments facultatifs de la liste de contrôle restent — vous pouvez terminer une fois les éléments requis terminés.",
},
pendingMedia: {
failedCaption_one: "{{count}} non envoyé — appuyez pour réessayer",
failedCaption_many: "{{count}} non envoyés — appuyez pour réessayer",
failedCaption_other: "{{count}} non envoyés — appuyez pour réessayer",
pendingCaption_one: "{{count}} enregistré sur cet appareil, en attente d'envoi",
pendingCaption_many: "{{count}} enregistrés sur cet appareil, en attente d'envoi",
pendingCaption_other: "{{count}} enregistrés sur cet appareil, en attente d'envoi",
retryA11y: "Réessayer d’envoyer cette capture",
pendingA11y: "Capture enregistrée sur cet appareil, en attente d'envoi",
},
sideProgressPanel: {
sections: "Sections",
noSections: "Aucune section",
general: "Général",
},
findingsReview: {
  notAnswered_other: "{{count}} sans réponse",
  notAnswered_many: "{{count}} sans réponse",
  notAnswered_one: "{{count}} sans réponse",
  failedNeedJob_other: "{{count}} points en échec ont besoin d’une intervention",
  failedNeedJob_many: "{{count}} points en échec ont besoin d’une intervention",
  failedNeedJob_one: "{{count}} point en échec a besoin d’une intervention",
reportArchived: "Rapport enregistré",
findingsNeedDecision_one: "{{count}} point en échec a besoin d’une intervention, ou d’une raison de le laisser.",
findingsNeedDecision_other: "{{count}} points en échec ont besoin d’une intervention, ou d’une raison de les laisser.",
noFindingsNeedFollowUp: "Aucune constatation ne nécessite un suivi.",
recommendedWorkPackages_one: "{{count}} intervention suggérée d’après les constats.",
recommendedWorkPackages_other: "{{count}} interventions suggérées d’après les constats.",
allClear: "Tous les éléments inspectés sont conformes.",
successfulItemsTitle: "Éléments conformes · {{count}}",
successfulItemsSummary: "Éléments conformes, sans action requise",
notRated: "Non évalué",
answerItem: "Rouvrir pour répondre",
planWork: "Confirmer l’intervention",
decisionA11y: "{{label}} : {{itemLabel}}",
uncertain: "Sans réponse",
urgentFinding: "Constat urgent",
failedFinding: "Point en échec",
findingsNeedDecision_many: "{{count}} points en échec ont besoin d’une intervention, ou d’une raison de les laisser.",
recommendedWorkPackages_many: "{{count}} interventions suggérées d’après les constats.",
},
vision: {
findingsGroup: "Constats supplémentaires",
keepWorking: "Continuer à travailler",
scan: {
group: "Scanner",
item: "Scanner",
groupHint: "Vision peut aider pour {{count}} contrôles sur {{total}}",
recommendedHint: "Recommandé : scannez d’abord cette section",
resultsReady: "Résultats prêts",
analysing: "Analyse en cours…",
open: "Ouvrir le scan",
removeFinding: "Supprimer le constat",
supportedByEvidence: "Étayé par une preuve visuelle",
cameraAssisted: "Assisté par caméra, aucune photo conservée",
},
walk: {
  cardActionUpload: "Ajouter des photos",
  cardTitleUpload: "Vérifier la pièce à partir de photos",
cardTitle: "Faire le tour avec l’appareil photo",
cardBody: "Vision peut répondre à {{count}} contrôles sur {{total}} à partir de ce qu’il voit et les remplit. Vous ne vérifiez que ce qu’il n’a pas vu ou dont il n’était pas sûr.",
cardAction: "Commencer le tour",
howTo: "Appuyez sur le bouton rouge, puis avancez lentement en marquant une courte pause à chaque élément de la liste.",
walking: "Analyse en cours… avancez lentement et marquez une pause à chaque élément. Appuyez sur Terminer une fois le tour fait.",
start: "Commencer le tour",
stop: "Mettre le tour en pause",
uploadTitle: "Ajouter des photos de toute la pièce",
autoFilled: "Rempli pour vous : {{count}}",
rushedTitle: "C’était rapide",
rushedBody: "Vous avez couvert {{total}} éléments en {{taken}} s. Marquez une pause d’environ 2 secondes à chacun (environ {{suggested}} s au total) pour que Vision voie tout nettement.",
keepScanning: "Continuer l’analyse",
finishAnyway: "Terminer quand même",
slowDown: "Ralentissez et tenez le téléphone stable",
},
capture: {
title: "Scanner",
uploadTitle: "Ajouter des photos à analyser",
manual: "Répondre manuellement",
moveSlowly: "Prenez quelques photos nettes de ce que cette section contrôle.",
damageTip: "Approchez-vous et photographiez le long du panneau en angle rasant : les bosses se voient dans les reflets.",
checklistToggle: "À capturer · {{done}}/{{total}}",
checklistToggleNoCount: "À capturer",
found: "trouvé",
removeFrameA11y: "Supprimer la photo {{index}}",
lowLight: "Plus de lumière nécessaire",
limitReached: "Limite de photos atteinte. Supprimez-en une pour en ajouter une autre.",
costHint_one: "L’analyse utilise {{count}} crédit · {{balance}} disponibles",
costHint_other: "L’analyse utilise {{count}} crédits · {{balance}} disponibles",
costHint_many: "L’analyse utilise {{count}} crédits · {{balance}} disponibles",
shutterA11y: "Prendre une photo",
finishCount: "Terminer le scan ({{count}})",
cameraBlocked: "L’accès à l’appareil photo est désactivé. Activez-le dans les réglages ou ajoutez plutôt des photos.",
cameraNeeded: "Autorisez l’accès à l’appareil photo pour scanner, ou ajoutez plutôt des photos.",
openSettings: "Ouvrir les réglages",
grant: "Autoriser l’appareil photo",
webNoLocal: "Ici, les photos sont analysées par AssetWRX dans le cloud. Vous vérifiez tout avant l’enregistrement.",
upload: "Importer des photos",
useCamera: "Utiliser l’appareil photo",
fromPhotos: "Ajouter depuis les photos",
failed: "Impossible d’ajouter cette photo. Réessayez.",
seedFailed: "Impossible d’ouvrir la photo. Prenez-en une nouvelle ou ajoutez-en une depuis vos photos.",
},
stage: {
reading_labels: "Lecture des étiquettes…",
checking_items: "Vérification des points d’inspection…",
reviewing_condition: "Examen de l’état visible…",
preparing_results: "Préparation des résultats…",
},
coverage: {
observed: "Observé",
partial: "Partiellement vu",
not_observed: "Non observé",
},
cloud: {
offline: "Vous êtes hors ligne : seuls les résultats de l’appareil sont affichés.",
switched_off: "L’analyse cloud est désactivée pour cet espace de travail. Seul ce que l’appareil a pu lire est affiché.",
nothing_to_scan: "Rien dans cette section ne peut être lu sur une photo. Répondez vous-même aux contrôles.",
no_credits: "Crédits IA insuffisants pour l’analyse cloud. Seul ce que l’appareil a pu lire est affiché.",
timeout: "L’analyse cloud a pris trop de temps. Seul ce que l’appareil a pu lire est affiché.",
blocked_content: "Ces photos n’ont pas pu être analysées dans le cloud. Seul ce que l’appareil a pu lire est affiché.",
failed: "L’analyse cloud n’a pas abouti. Seul ce que l’appareil a pu lire est affiché.",
analyseNow: "Analyser avec l’IA maintenant · {{cost}}",
retry: "Relancer l’analyse cloud",
},
review: {
title: "Vérifier les suggestions",
emptyTitle: "Impossible de déterminer ces contrôles à partir du scan",
emptyBody: "Scannez à nouveau avec l’élément bien visible, ou répondez vous-même aux contrôles.",
summaryReady: "Prêts : {{count}}",
summaryCheck: "À vérifier : {{count}}",
summaryNotSeen: "Non vus : {{count}}",
summaryIssues: "Problèmes possibles : {{count}}",
frameA11y: "Photo du scan {{index}}",
readyTitle: "Prêt à confirmer",
checkTitle: "À vérifier",
notObservedTitle: "Non observé",
issuesTitle: "Problèmes supplémentaires",
coverageTitle: "Ce que le scan a couvert",
acceptReady: "Accepter les réponses prêtes ({{count}})",
bulkSaved: "Réponses enregistrées : {{count}}",
undo: "Annuler",
done: "Terminé",
scanAgain: "Scanner à nouveau",
completeManually: "Répondre manuellement",
leaveTitle: "Quitter sans vérifier ?",
leaveBody: "Certaines suggestions de ce scan n'ont pas été vérifiées. Si vous quittez maintenant, elles seront supprimées.",
keepReviewing: "Continuer la vérification",
discard: "Supprimer",
observed: "Observé",
suggested: "Suggéré",
differs: "Diffère de votre réponse. L’accepter la remplace.",
partial: "Seulement en partie visible. Vérifiez avant d’accepter.",
conflict: "Les relevés ne concordent pas. Choisissez la bonne valeur.",
previousReading: "Dernier relevé : {{value}}",
backwards: "Inférieur au dernier relevé enregistré.",
unitMismatch: "Ce compteur est enregistré en {{unit}}.",
serialMismatch: "Ne correspond pas au numéro de série enregistré de cet actif.",
accept: "Accepter",
change: "Modifier",
reject: "Rejeter",
save: "Enregistrer",
possibleIssue: "Problème possible",
confirmIssue: "Confirmer le problème",
flagIssue: "Signaler pour vérification",
noIssue: "Aucun problème",
decision: {
accepted: "Enregistré",
changed: "Enregistré avec votre modification",
rejected: "Non utilisé",
fail: "Ajouté aux constats supplémentaires",
flag: "Signalé dans les constats supplémentaires",
dismissed: "Écarté",
},
reason: {
not_observed: "Non visible sur les photos.",
partial: "Seulement en partie visible.",
low_confidence: "Pas assez net pour suggérer une réponse.",
no_evidence: "Rien dans le scan ne répond à ce point.",
},
},
defect: {
corrosion: "Corrosion",
leak: "Fuite",
crack: "Fissure",
wear: "Usure",
deformation: "Déformation",
missing_component: "Composant manquant",
loose_component: "Composant desserré",
damage: "Dommage",
contamination: "Contamination",
damp_staining: "Taches d’humidité",
mould_growth: "Développement de type moisissure",
blockage: "Obstruction",
overheating: "Surchauffe",
dent: "Bosse",
scratch: "Rayure",
paint_damage: "Dommage de peinture",
glazing_damage: "Vitrage endommagé",
light_damage: "Feu endommagé",
tyre_damage: "Pneu endommagé",
cable_damage: "Câble endommagé",
exposed_wiring: "Câblage apparent",
misalignment: "Désalignement",
blocked_access: "Accès bloqué",
other_visible_anomaly: "Élément à vérifier",
},
trainingShare: {
title: "Données d'amélioration de Vision",
body: "Vision conserve la trace des suggestions que votre équipe a acceptées, modifiées ou rejetées, sans photos, pour mesurer sa précision. Ce paramètre est activé par défaut : les photos de preuve conservées pour ces suggestions servent aussi à entraîner Vision. Elles sont copiées vers Google Cloud dans l'UE pour l'entraînement et y sont supprimées sous 30 jours. Le désactiver arrête toute utilisation ultérieure ; un modèle déjà entraîné avec elles n'est pas désentraîné. Les enregistrements sont conservés 24 mois.",
toggle: "Utiliser nos photos de preuve pour améliorer Vision",
on: "Activé. Les photos de preuve des suggestions vérifiées peuvent être copiées dans Google Cloud (UE) pour entraîner Vision.",
off: "Désactivé. Seules les décisions de vérification sont conservées, sans photos.",
failed: "Impossible de modifier ce réglage. Réessayez.",
retry: "Réessayer",
},
},
ratingScale: {
poor: "Mauvais",
fair: "Passable",
good: "Bon",
veryGood: "Très bon",
excellent: "Excellent",
low: "Bas",
quarter: "Un quart",
half: "Moitié",
threeQuarter: "Trois quarts",
full: "Plein",
},
};
